module.exports = __webpack_public_path__ + "static/img/qiangchai2.56f2773.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/qiangchai2.png
// module id = Lzd0
// module chunks = 24